import AgoraRTC, { IAgoraRTCClient } from "agora-rtc-react";
import React from "react";

export const useAgoraClient = () => {
  const clientRef = React.useRef<IAgoraRTCClient | null>(null);

  if (!clientRef.current) {
    AgoraRTC.setLogLevel(3); // 0: DEBUG, 1: INFO, 2: WARN, 3: ERROR, 4: NONE
    clientRef.current = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
  }

  React.useEffect(() => {
    return () => {
      if (clientRef.current) {
        clientRef.current.leave();
      }
    };
  }, []);

  return {
    client: clientRef.current,
  };
};
